// Dependencies
import { useState, useEffect, useRef, useCallback, useContext } from "react";
import { ReactSVG } from "react-svg";
import { Portal } from 'react-portal';

// Types
import { Types, Components } from '../types';

// Utils
import { WP_PLUGIN_BASE_PATH } from '../utils/config'

// Hooks
import { useDebug } from "../hooks";
 
// Components
import { MinicartContext } from "../contexts/Minicart";
import styled, { css } from "styled-components";
import Icon from "./Icon";

// const SidebarHeaderWrapper = styled.div<any>(({ theme: { general: { transition, ...general }, components: {cartItem: styles} } }) => css`

// `)

const SidebarHeaderWrapper = styled.div<any>(({ theme: { general: { transition, ...general }, components: {sidebarHeader: styles} } }) => css`
        display: flex;
        align-items: center;
        //z-index: 1;

        padding: clamp(1.35em, 5vw, 1.625em);

        color: ${styles.textColor};
        background-color: ${styles.background};

        .wooptima-minicart-sidebar-header {
            &__icon {
                > div {
                    display: flex;
                }
                svg {
                    color: ${styles.iconColor};
                }
                margin-right: 0.5em;
            }
    
            &__label {
                font-size: clamp(1.35em, 5vw, 1.5em);
                line-height: 1;
            }
    
            &__quantity {
                display: flex;
                align-items: center;
                justify-content: center;
                
                width: clamp(1.35em, 5vw, 1.5em);
                height: clamp(1.35em, 5vw, 1.5em);
        
                margin-left: .75em;
    
                padding: 0.25em;
                border-radius: 50%;
    
                > span {
                    font-size: 0.75em;
                    line-height: 1;
                }
    
                color: ${styles.background};
                background-color: ${styles.textColor};
            }
    
            &__close {
                cursor: pointer;
                padding: 0.25em;
                margin-left: auto;
                border-radius: 50%;
                -webkit-tap-highlight-color: transparent;
                transition: all ${transition.duration} ${transition.timingFunction};
                transition-duration: 100ms;
                line-height: 1;
    
                > div {
                    width: 1em;
                    height: 1em;
                }
        
                &:active {
                    background-color: #ffffff40;
                    box-shadow: 0 0 0 .5em #ffffff40;
                }
            }
        }
`)

const SidebarHeader = ({ className }: any) => {
    
    useDebug('SidebarHeader'); 

    // Contexts
    const { itemsCount, toggleState, translations, theme } = useContext( MinicartContext );
    
    return (<>
        <SidebarHeaderWrapper className={`${className}`}>

            <Icon
                fill={theme.components.sidebarHeader.iconColor}
                size={1.5}
                tabIndex={0}
                role="button"
                id="cartDefault"
                className={`${className}__icon`}
            />

            <strong className={`${className}__label`}>{translations.cartHeader.title}</strong>

            <div className={`${className}__quantity`}>
                <span>{itemsCount}</span>
            </div>

            <ReactSVG
                tabIndex={0}
                role="button"
                className={`${className}__close`}
                src={`${WP_PLUGIN_BASE_PATH}/assets/icons/${'ico-cross'}.svg`}
                onClick={() => toggleState('opened', false)}
            />

        </SidebarHeaderWrapper> 
    </>)
}

export default SidebarHeader;